
if ($("#_EducatorQualifications").length > 0) {
    
    console.log('_EducatorQualifications detected');

    var EducatorId;
    var TrainingId;
    var ReturnURL;

    $(document).on('click', '.btnEducatorQualificationDel', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var self = $(this);

        //Set the employee, wsp application and training ids
        EducatorId = self.data('educatorid');
        TrainingId = self.data('trainingid');
        ReturnURL = self.data('returnurl');
        
        //Display the Delete Model window       
        $("#educatorQualificationDeleteModal").modal();
    });

    //btnQualificationDeleteYes
    //Respond to the button delete file click event    
    $(document).on('click', '#btnQualificationDeleteYes', function (e) {
        var url = '';
        var self = $(this);

        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/educator/home/DeleteEducatorQualification/';
        } else {
            url = location.href.split('/fr/')[0] + '/fr/educator/home/DeleteEducatorQualification/';
        }

        $.ajax({
            url: url + '?EducatorId=' + EducatorId + '&TrainingId=' + TrainingId ,
            method: 'POST',
            contentType: false,
            processData: false,
            success: function (res) {
                url = url.replace('DeleteEducatorQualification', 'GetEducatorQualificationListPartial') + '?id=' + EducatorId + '&ReturnURL=' + ReturnURL;
                $("#_EducatorQualifications").load(url, function () {
                    $("#educatorQualificationModal").modal();

                    //Upload the file list if the file upload form is displayed
                    if ($("#_fileUpload").length > 0) {
                        if (typeof refreshFileList === "function") {
                            refreshFileList();
                        };
                    };
                });
            },
            error: function () {
                url = url.replace('DeleteEducatorQualification', 'GetEducatorQualificationListPartial') + '?id=' + EducatorId + '&ReturnURL=' + ReturnURL;
                $("#_EducatorQualifications").load(url, function () {
                    $("#educatorQualificationModal").modal();

                    //Upload the file list if the file upload form is displayed
                    if ($("#_fileUpload").length > 0) {
                        if (typeof refreshFileList === "function") {
                            refreshFileList();
                        };
                    };
                });
            }
        });
    });
}